export const AUTH_MODAL = 'auth-modal';
export const NO_METAMASK_MODAL = 'no-metamask';
export const TRANSACTION_PENDING_MODAL = 'transaction-pending';
export const SEND_ALLOCATION_ADDRESS_MODAL = 'send-allocation-address';
